import React from "react";
import "../Styles/privacy.css";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";

function TermsAndConditions() {
  const navigate = useNavigate();
  return (
    <div className="privacyMain">
      <div className="backbtn">
        <MdArrowBackIosNew
          onClick={() => navigate(-1)}
          style={{
            color: "black",
            fontSize: "26px",
            marginLeft: "5px",
            marginTop: "5px",
            cursor: "pointer",
          }}
        />
      </div>
      <div className="privacypolicy">
        <h6>TERMS & CONDITIONS</h6>
        <br />
        <p>
          This document is published in accordance with the provisions of Rule 3
          (1) of the Information Technology (Intermediaries guidelines) Rules,
          2011 that requires publishing the rules and regulations, Privacy
          Policy and Terms of Use for access or usage of our Website/App
          www.Dailydish.in (“Website/App”) and for the mobile application
          Dailydish Fresh Food Delivery(“App”)
        </p>
        <p className="mt-1">
          For the purpose of these Terms of Use, wherever the context so
          requires "You" or "User" shall mean any natural or legal person who
          visits our platform, either just for the purpose of browsing the
          Website/App/App or engages to buy our products. The term "We", "Us",
          "Our" shall mean Chef Studio Innovation(“DailyDish”).
        </p>
        These Terms of Service apply to all users of the site, including without
        limitation users who are browsers, vendors, customers, merchants, and/
        or contributors of content. Please read these Terms of Service carefully
        before accessing or using Our Website/App. By accessing or using any
        part of the site, you agree to be bound by these Terms of Service. If
        you do not agree to all the terms and conditions of this agreement, then
        you may not access the Website/App or use any services. If these Terms
        of Service are considered an offer, acceptance is expressly limited to
        these Terms of Service. Any new features or tools which are added to the
        current store shall also be subject to the Terms of Service. You can
        review the most current version of the Terms of Service at any time on
        this page. We reserve the right to update, change or replace any part of
        these Terms of Service by posting updates and/or changes to Our
        Website/App. It is your responsibility to check this page periodically
        for changes. Your continued use of or access to the Website/App
        following the posting of any changes constitutes acceptance of those
        changes.
        <br />
        <h6>SECTION 1 - GENERAL CONDITIONS</h6>
        <br />
        <p>
          1.1 By agreeing to these Terms of Service, You represent that you are
          at least 18 (Eighteen) years of age and you have given us your consent
          to allow any of your minor dependents to use this site. You may not
          use our products for any illegal or unauthorized purpose nor may You,
          in the use of the Service, violate any laws in your jurisdiction
          (including but not limited to copyright laws). You must not transmit
          any worms or viruses or any code of a destructive nature. A breach or
          violation of any of the Terms will result in an immediate termination
          of your Services.
        </p>
        <p>
          1.2 We reserve the right to refuse service to anyone for any reason at
          any time. You understand that your content (not including credit card
          information), may be transferred unencrypted and involve (a)
          transmissions over various networks; and (b) changes to conform and
          adapt to technical requirements of connecting networks or devices.
          Credit card information is always encrypted during transfer over
          networks. You agree not to reproduce, duplicate, copy, sell, resell or
          exploit any portion of the Service, use of the Service, or access to
          the Service or any contact on the Website/App through which the
          service is provided, without express written permission by us. The
          headings used in this agreement are included for convenience only and
          will not limit or otherwise affect these Terms.
        </p>
        <br />
        <h6>SECTION 2:MODIFICATIONS TO THE SERVICE AND PRICES</h6>
        <br />
        <p>
          2.1 Prices for our products are subject to change without notice. We
          reserve the right at any time to modify or discontinue the Service (or
          any part or content thereof) without notice at any time. We shall not
          be liable to you or to any third-party for any modification, price
          change, suspension or discontinuance of the Service.
        </p>
        <br />
        <h6>SECTION 3 - PRODUCTS OR SERVICES</h6>
        <p>
          3.1 Certain products or services may be available exclusively online
          through the Website/App. These products or services may have limited
          quantities and are subject to return or exchange only according to Our
          Return Policy. We reserve the right, but are not obligated, to limit
          the sales of Our products or Services to any person, geographic region
          or jurisdiction. We may exercise this right on a case-by-case basis.
          We reserve the right to limit the quantities of any products or
          services that we offer. All descriptions of products or product
          pricing are subject to change at any time without notice, at Our sole
          discretion. We reserve the right to discontinue any product at any
          time. Any offer for any product or service made on this site is void
          where prohibited. We do not warrant that the quality of any products,
          services, information, or other material purchased or obtained by You
          will meet your expectations, or that any errors in the Service will be
          corrected.
        </p>
        <br />
        <h6>SECTION 4 - ACCURACY OF BILLING AND ACCOUNT INFORMATION</h6>
        <p>
          4.1 We reserve the right to refuse any order You place with Us. We
          may, at Our sole discretion, limit or cancel quantities purchased per
          person, per household or per order. These restrictions may include
          orders placed by or under the same customer account, the same credit
          card, and/or orders that use the same billing and/or shipping address.
          In the event that We make a change to or cancel an order, We may
          attempt to notify You by contacting the e-mail and/or billing
          address/phone number provided at the time the order was made. You
          agree to provide current, complete and accurate purchase and account
          information for all purchases made at Our store.
        </p>
        <br />
        <h6>SECTION 5 - OPTIONAL TOOLS</h6>
        <p>
          5.1 We may provide You with access to third-party tools which are
          different payment gateways over which We neither monitor nor have any
          control nor input. You acknowledge and agree that We provide access to
          such tools “as is” and “as available” without any warranties,
          representations or conditions of any kind and without any endorsement.
        </p>
        <p>
          5.2 We shall have no liability whatsoever arising from or relating to
          your use of optional third-party tools. Any use by You of optional
          tools offered through the site is entirely at your own risk and
          discretion and You should ensure that You are familiar with and
          approve of the terms on which tools are provided by the relevant
          third-party provider(s). We may also, in the future, offer new
          services and/or features through the Website/App (including, the
          release of new tools and resources). Such new features and/or services
          shall also be subject to these Terms of Service.
        </p>
        <br />
        <h6>SECTION 6 - THIRD-PARTY LINKS</h6>
        <p>
          6.1 Certain content, products and services available via our Service
          may include materials from third- parties. Third-party links on this
          site may direct you to third-party Website/Apps that are not
          affiliated with us. We are not responsible for examining or evaluating
          the content or accuracy and we do not warrant and will not have any
          liability or responsibility for any third-party materials or
          Website/Apps, or for any other materials, products, or services of
          third-parties. We are not liable for any harm or damages related to
          the purchase or use of goods, services, resources, content, or any
          other transactions made in connection with any third-party
          Website/Apps
        </p>
        <p>
          6.2 Please review carefully the third-party's policies and practices
          and make sure You understand them before You engage in any
          transaction. Complaints, claims, concerns, or questions regarding
          third- party products should be directed to the third-party.
        </p>
        <br />
        <h6>SECTION 7 - PERSONAL INFORMATION</h6>
        <p>
          7.1 Your submission of personal information through the Webiste/App is
          governed by our Privacy Policy. To view our Privacy Policy.
        </p>
        <br />
        <h6>SECTION 8 - ERRORS, INACCURACIES AND OMISSIONS</h6>
        <p>
          8.1 Occasionally there may be information on Our site or in the
          service that contains typographical errors, inaccuracies or omissions
          that may relate to product descriptions, pricing, promotions, offers,
          product shipping charges, transit times and availability. We reserve
          the right to correct any errors, inaccuracies or omissions, and to
          change or update information or cancel orders if any information in
          the service or on any related Website/App is inaccurate at any time
          without prior notice (including after You have submitted your order).
          We undertake no obligation to update, amend or clarify information in
          the Service or on any related Website/App, including without
          limitation, pricing information, except as required by law. No
          specified update or refresh date applied in the Service or on any
          related Website/App, should be taken to indicate that all information
          in the Service or on any related Website/App has been modified or
          updated.
        </p>
        <br />
        <h6>SECTION 9 - PROPRIETARY RIGHTS</h6>
        <p>
          9.1 All materials on the Website/App, including, without limitation,
          names, logos, trademarks, images, text, columns, graphics, videos,
          photographs, illustrations, artwork, software and other elements
          (collectively, “Material”) are protected by copyrights, trademarks
          and/or other intellectual property rights owned and controlled by
          Dailydish.in, You acknowledge and agree that all Material on the
          Website/App is made available for limited, non-commercial, personal
          use only. Except as specifically provided herein or elsewhere in the
          Website/App, no Material may be copied, reproduced, republished, sold,
          downloaded, posted, transmitted, or distributed in any way, or
          otherwise used for any purpose, by any person or entity, without
          express written permission of Dailydish.in. You may not add, delete,
          distort, or otherwise modify the Material. Any unauthorized attempt to
          modify any Material, to defeat or circumvent any security features, or
          to utilize the App or any part of the Material for any purpose other
          than its intended purposes is strictly prohibited.
        </p>
        <p>
          9.2 The Website/App may not be used in connection with any commercial
          purposes, except as specifically approved by Dailydish.in.
        </p>
        <br />
        <h6>SECTION 10 - PROHIBITED USE</h6>
        <p>
          10.1 In addition to other prohibitions as set forth in the Terms of
          Service, You are prohibited from using the site or its content: (a)
          for any unlawful purpose; (b) to solicit others to perform or
          participate in any unlawful acts; (c) to violate any international,
          federal, provincial or state regulations, rules, laws, or local
          ordinances; (d) to infringe upon or violate our intellectual property
          rights or the intellectual property rights of others; (e) to harass,
          abuse, insult, harm, defame, slander, disparage, intimidate, or
          discriminate based on gender, sexual orientation, religion, ethnicity,
          race, age, national origin, or disability; (f) to submit false or
          misleading information; (g) to upload or transmit viruses or any other
          type of malicious code that will or may be used in any way that will
          affect the functionality or operation of the Service or of any related
          Website/App, other Website/Apps, or the Internet; (h) to collect or
          track the personal information of others; (i) to spam, phish, pharm,
          pretext, spider, crawl, or scrape; (j) for any obscene or immoral
          purpose; or (k) to interfere with or circumvent the security features
          of the service or any related Website/App, other Website/Apps, or the
          Internet. We reserve the right to terminate your use of the service or
          any related Website/App for violating any of the prohibited uses.
        </p>
        <br />
        <h6>SECTION 11 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h6>
        <p>
          11.1 We do not guarantee, represent or warrant that your use of our
          service will be uninterrupted, timely, secure or error-free. We do not
          warrant that the results that may be obtained from the use of the
          service will be accurate or reliable. You agree that from time to time
          we may remove the service for indefinite periods of time or cancel the
          service at any time, without notice to You. You expressly agree that
          your use of, or inability to use, the service is at your sole risk.
          The service and all products and services delivered to You through the
          service are (except as expressly stated by us) provided 'as is' and
          'as available' for your use, without any representation, warranties or
          conditions of any kind, either express or implied, including all
          implied warranties or conditions of merchantability, merchantable
          quality, fitness for a particular purpose, durability, title, and
          non-infringement. In no case shall We, our directors, officers,
          employees, affiliates, agents, contractors, interns, suppliers,
          service providers or licensors be liable for any injury, loss, claim,
          or any direct, indirect, incidental, punitive, special, or
          consequential damages of any kind, including, without limitation lost
          profits, lost revenue, lost savings, loss of data, replacement costs,
          or any similar damages, whether based in contract, tort (including
          negligence), strict liability or otherwise, arising from your use of
          any of the service or any products procured using the service, or for
          any other claim related in any way to your use of the service or any
          product, including, but not limited to, any errors or omissions in any
          content, or any loss or damage of any kind incurred as a result of the
          use of the service or any content (or product) posted, transmitted, or
          otherwise made available via the service, even if advised of their
          possibility
        </p>
        <br />
        <h6>SECTION 12 – INDEMNIFICATION</h6>
        <p>
          12.1 You agree to indemnify, defend and hold harmless Us and Our
          parent, subsidiaries, affiliates, partners, officers, directors,
          agents, contractors, licensors, service providers, subcontractors,
          suppliers, interns and employees, harmless from any claim or demand,
          including reasonable attorneys’ fees, made by any third-party due to
          or arising out of your breach of these Terms of Service or the
          documents they incorporate by reference, or your violation of any law
          or the rights of a third-party.
        </p>
        <br />
        <h6>SECTION 13 – SEVERABILITY</h6>
        <p>
          13.1 In the event that any provision of these Terms of Service is
          determined to be unlawful, void or unenforceable, such provision shall
          nonetheless be enforceable to the fullest extent permitted by
          applicable law, and the unenforceable portion shall be deemed to be
          severed from these Terms of Service, such determination shall not
          affect the validity and enforceability of any other remaining
          provisions.
        </p>
        <br />
        <h6>SECTION 14 - GOVERNING LAW</h6>
        <p>
          14.1 These Terms of Service and any separate agreements whereby we
          provide you Services shall be governed by and construed in accordance
          with the laws of India and shall be subject to the jurisdiction of the
          courts in Bangalore.
        </p>
        <br />
        <h6>SECTION 15 - CANCELLATION AND REFUND POLICY</h6>
        <p>
          15.1 The cancellation of any order made by You should be cancelled
          within 1 (one) minutes of placing the order. Any cancellation made
          after such period of one minutes shall not be entertained and We shall
          be entitled to receive the entire amount of the order placed by You.
        </p>
        <p>
          15.2 We are sure you would love our food. In case you were not happy
          with your Dailydish meal, let us know at Orders@dailydish.in.
          Dailydish reserves the right to refund the entire amount for the
          order.
        </p>
        <br />
        <h6>SECTION 16 - GENERAL</h6>
        <p>
          16.1 We reserves the right to amend this Terms of Use at any time and
          without notice, and it is your responsibility to review this Terms of
          Use for any changes. Your use of the Website/App following any
          amendment of this Terms of Use will signify your assent to and
          acceptance of its revised terms.
        </p>
        <p>
          16.2 In case of any grievance arising from the use of the Website/App,
          please contact the Grievance Officer within 24 hours and the same
          shall be redressed within 48 hours from receipt of such complaint.
        </p>
        <br />
        <h6>SECTION 17 – ACCOUNT DELETION</h6>
        <p>
          17.1 - Customer willing to delete his/her account can send a mail to
          Orders@dailydish.in
        </p>
        <p>
          17.2 - Customer profile will be deleted from our database, which also
          includes, Name, email, DOB, Address, Orders, Payment details.
        </p>
        <p>
          17.3 - In all matters relating to account deletion, the decision of
          Dailydish shall be final and binding and by participating in the
          offer, the participants agree to be bound by the terms and conditions
          contained herein.
        </p>
        <br />
        <h6>SECTION 18 – DATA SECURITY PRECAUTIONS</h6>
        <p>
          We have in place appropriate technical and security measures to secure
          the information collected by us.
        </p>
        <p>
          We use vault and tokenization services from third party service
          providers to protect the sensitive personal information provided by
          you. The third-party service providers with respect to our vault and
          tokenization services and our payment gateway and payment processing
          are compliant with the payment card industry standard (generally
          referred to as PCI compliant service providers). You are advised not
          to send your full credit/debit card details through unencrypted
          electronic platforms. Where we have given you (or where you have
          chosen) a username and password which enables you to access certain
          parts of the Dailydish Platform, you are responsible for keeping these
          details confidential. We ask you not to share your password with
          anyone. Please we aware that the transmission of information via the
          internet is not completely secure. Although we will do our best to
          protect your personal data, we cannot guarantee the security of your
          data transmitted through the Dailydish Platform. Once we have received
          your information, we will use strict physical, electronic, and
          procedural safeguards to try to prevent unauthorised access.
        </p>
        <br />
        <h6>SECTION 19 – OPT-OUT</h6>
        <p>
          When you sign up for an account, you are opting in to receive emails
          and SMS/whatsapp message from Dailydish. In order to “unsubscribe”
          please send out a mail to Orders@dailydish.in, but note that you
          cannot opt out of receiving certain administrative notices, service
          notices, or legal notices from Dailydish.in. If you wish to withdraw
          your consent for the use and disclosure of your personal information
          in the manner provided in this Policy, please write to us at
          Orders@dailydish.in. Please note that we may take time to process such
          requests, and your request shall take effect no later than 5 (Five)
          business days from the receipt of such request, after which we will
          not use your personal data for any processing unless required by us to
          comply with our legal obligations. We may not be able offer you any or
          all Services upon such withdrawal of your consent.
        </p>
        <br />
        <h6>SECTION 20 – COOKIES</h6>
        <p>
          Our Dailydish Platform and third parties with whom we partner, may use
          cookies, pixel tags, web beacons, mobile device IDs, “flash cookies”
          and similar files or technologies to collect and store information
          with respect to your use of the Services and third-party websites.
        </p>
        <p>
          Cookies are small files that are stored on your browser or device by
          websites, apps, online media and advertisements. We use cookies and
          similar technologies for purposes such as:
        </p>
        <ul>
          <li>Authenticating users.</li>
          <li>Remembering user preferences and settings.</li>
          <li>Determining the popularity of content.</li>
          <li>
            Delivering and measuring the effectiveness of advertising campaigns
          </li>
          <li>
            Analysing site traffic and trends, and generally understanding the
            online behaviours and interests of people who interact with our
            services.
          </li>
          <li>
            A pixel tag (also called a web beacon or clear GIF) is a tiny
            graphic with a unique identifier, embedded invisibly on a webpage
            (or an online ad or email), and is used to count or track things
            like activity on a webpage or ad impressions or clicks, as well as
            to access cookies stored on users’ computers. We use pixel tags to
            measure the popularity of our various pages, features and services.
            We also may include web beacons in e-mail messages or newsletters to
            determine whether the message has been opened and for other
            analytics.
          </li>
        </ul>
        <p>
          To modify your cookie settings, please visit your browser’s settings.
          By using our Services with your browser settings to accept cookies,
          you are consenting to our use of cookies in the manner described in
          this section.
        </p>
        <p>
          We may also allow third parties to provide audience measurement and
          analytics services for us, to serve advertisements on our behalf
          across the Internet, and to track and report on the performance of
          those advertisements. These entities may use cookies, web beacons,
          SDKs and other technologies to identify your device when you visit the
          DailyDish Platform and use our Services, as well as when you visit
          other online sites and services.
        </p>
        <p>
          Please see our Cookie Policy for more information regarding the use of
          cookies and other technologies described in this section, including
          regarding your choices relating to such technologies.
        </p>
        <br />
        <h6>SECTION 21 – USES OF YOUR INFORMATION</h6>
        <p>
          We use the information we collect for following purposes, including:
        </p>
        <ul>
          <li>
            To provide, personalise, maintain and improve our products and
            services, such as to enable deliveries and other services, enable
            features to personalise your Dailydish account.
          </li>
          <li>
            To carry out our obligations arising from any contracts entered into
            between you and us and to provide you with the relevant information
            and services.
          </li>
          <li>
            To administer and enhance the security of our Dailydish Platform and
            for internal operations, including troubleshooting, data analysis,
            testing, research, statistical and survey purposes
          </li>
          <li>
            To provide you with information about services we consider similar
            to those that you are already using, or have enquired about, or may
            interest you. If you are a registered user, we will contact you by
            electronic means (e-mail or SMS or telephone) with information about
            these services
          </li>
          <li>
            To understand our users (what they do on our Services, what features
            they like, how they use them, etc.), improve the content and
            features of our Services (such as by personalizing content to your
            interests), process and complete your transactions, make special
            offers, provide customer support, process and respond to your
            queries
          </li>
          <li>
            To generate and review reports and data about, and to conduct
            research on, our user base and Service usage patterns.
          </li>
          <li>
            To allow you to participate in interactive features of our Services,
            if any or
          </li>
          <li>
            To measure or understand the effectiveness of advertising we serve
            to you and others, and to deliver relevant advertising to you.
          </li>
          <li>
            If you are a partner restaurant or merchant or delivery partner, to
            track the progress of delivery or status of the order placed by our
            customers
          </li>
          <li>to carry out academic research with academic partners.</li>
          <li>
            We may combine the information that we receive from third parties
            with the information you give to us and information we collect about
            you for the purposes set out above. Further, we may anonymize and/or
            de-identify information collected from you through the Services or
            via other means, including via the use of third-party web analytic
            tools. As a result, our use and disclosure of aggregated and/or
            de-identified information is not restricted by this Policy, and it
            may be used and disclosed to others without limitation.
          </li>
          <li>
            We analyse the log files of our Dailydish Platform that may contain
            Internet Protocol (IP) addresses, browser type and language,
            Internet service provider (ISP), referring, app crashes, page viewed
            and exit websites and applications, operating system, date/time
            stamp, and clickstream data. This helps us to administer the
            website, to learn about user behavior on the site, to improve our
            product and services, and to gather demographic information about
            our user base as a whole.
          </li>
        </ul>
        <br />
        <h6>SECTION 22 – POLICY CHANGES</h6>
        <p>
          We may occasionally update this Policy and such changes will be posted
          on this page. If we make any significant changes to this Policy we
          will endeavour to provide you with reasonable notice of such changes,
          To the extent permitted under the applicable law, your continued use
          of our Services after we publish or send a notice about our changes to
          this Policy shall constitute your consent to the updated Policy.
        </p>
        <br />
        <h6>SECTION 23 – DELIVERY ,DELIVERY FEE,OTHER FEE AND DELIVERY TIME</h6>
        <p>
          Last mile delivery charges are for the delivery services forming part
          of the sale of Products purchased by You on the Platform.<b> Customers
          can place lunch orders between 8:00 AM to 12:30 PM and Dinner orders
          between 3:00 PM and 8:30 PM , Lunch will be Delivered during time
          slots of 12:30 PM to 1:00 PM or 1:00 PM to 1:30 PM as selected by
          customers, Dinners will be deliverd during 8:30 PM to 9:00 PM or 9:00 to 9:30 PM as selected by customers.</b> The Company shall
          provide delivery of the Products upon purchase during such time period
          as communicated to You through the Platform. The Company endeavours to
          show the estimated delivery time for every order, however, the Company
          does not guarantee the delivery within the said time, since the exact
          delivery time of each order may vary due to various factors such as
          availability of third party delivery service providers, demand,
          traffic and weather conditions, a force majeure event, etc. Company
          endeavors to deliver the orders within a time slot, it may be possible
          that the delivery time may exceed then the claimed time due to the
          aforementioned reasons, when You go to the checkout of the sit even
          before placing an order you can select the time slot, to ensure that
          You are aware of the ETA before proceeding with placing an order. You
          agree that the Company reserves the right to charge. which You can see
          on the view bill section on checkout page The delivery of the Products
          will be made to the delivery address specified by You while placing
          the order for the Products on the Platform. You are solely responsible
          for providing a complete and correct delivery address and, if
          applicable, further instructions for delivery. The Company shall not
          be responsible for any delay in delivering the order placed by You on
          the Platform caused due to the incorrect or incomplete address
          provided by You. The goods will ordinarily be delivered when an
          appropriate person is able to receive the order at the address and
          destination provided by You. If You request to leave a delivery
          unattended at Your address, You expressly disclaim the Company from
          all the liabilities which may arise by virtue of the Products being
          left unattended for a period of time. This includes but is not limited
          to theft, tampering, contamination, and the result of any change in
          temperature of the items which need to be kept chilled or frozen.
        </p>
        <br />
        <h6>SECTION 24 – RETURNS</h6>
        <p>
          You may return the Product in an order, subject to the following,
          conditions:
        </p>
        <ul>
          <li>
            wrong item being delivered other than what You had ordered in an
            order or
          </li>
          <li>
            Items substantially damaged or deteriorated in quality at the time
            of delivery. You agree that You shall give Us all the requisite
            proofs including but not limited to images of Products having
            issues.
          </li>
          <li>
            You may request exchange or return the Products, purchased from Us
            provided the Products are sealed/unopened/unused and in original
            condition and on the same day of delivery. Please note, the requests
            for exchange or returns will not be accepted from the day following
            the day when We had delivered the Product/s to You. We may request
            You to dispose off the Products for which We have processed a
            refund.
          </li>
        </ul>
        <br />
        <h6>SECTION 25 – CANCELLATIONS</h6>
        <p>
          You may cancel an order without charge at any time before the Company
          accepts the order. You cannot cancel the order post acceptance of
          order by the Company. The Company may cancel an order (in full or
          partially) for the reasons including shortage or unavailability of
          certain Products or force majeure events. In case the Company cancels
          any order, You will not be charged for such cancellations, and the
          Company will refund You for any payment already made.
        </p>
        <br />
        <h6>SECTION 26 – REFUNDS</h6>
        <p>
          Please be informed that when You opt to cancel or return the Products,
          upon our verification of the Products and the documents relating
          thereto, the refund amount for such Products which are eligible for
          return as per these Terms, will be processed within a period of seven
          (7) business days from the date of us verifying and confirming the
          refund request.  The refund amount will be
          credited to the source account. You acknowledge that after initiation
          of refund, it may take<b> 7 days.</b> 
        </p>
        <p>
          The terms for acceptance of returns, cancellation and refunds shall be
          subject to reasonable additional conditions and shall be communicated
          to the User, from time to time, through the push notifications on the
          Platform, or any other mode of communication as specified in these
          Terms or as determined by the Company.
        </p>
        <br />
        <p>Last updated on 26 October 2024</p>
      </div>
    </div>
  );
}

export default TermsAndConditions;
